import { render, staticRenderFns } from "./CiExtrasList.vue?vue&type=template&id=04df5edb&"
import script from "./CiExtrasList.vue?vue&type=script&lang=js&"
export * from "./CiExtrasList.vue?vue&type=script&lang=js&"
import style0 from "./CiExtrasList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CiExtrasList.vue"
export default component.exports